/** @format */

interface Options {
  value?: number | string;
  token?: string;
}

const getValueWithToken = ({value, token}: Options): string => {
  const myValue = value === undefined || value === '' ? 0 : value;
  const suffix = token ? ` ${token}` : '';
  return `${myValue}${suffix}`;
};

export default getValueWithToken;
